define('views/header',["exports", "underscore", "jquery", "backbone", "headroom", "common", "typeahead"], function (_exports, _underscore, _jquery, _backbone, _headroom, _common, _typeahead) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _jquery = _interopRequireDefault(_jquery);
  _headroom = _interopRequireDefault(_headroom);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
  var MODE_TEMPLATE = (0, _underscore.template)(`
<div class=b-search__item>
    <div class=b-search-mode>
    <span class="b-search-mode__title b-search-mode__title--<%- mode %>"><%- title %></span>
    <span class=b-search-mode__tagline><%- description %></span>
    </div>
</div>`);
  var RENT_TEMPLATE = (0, _underscore.template)(`
<div class="b-search__item b-search-rental">
    <img src="<%- thumb %>" class=b-search-rental__img>
    <div class=b-search-rental__text>
    <div class=b-search-rental__title><%- title %></div>
    <div class=b-search-rental__meta>
    <span class="stars b-search-rental__stars"><span class="stars__star stars__star--<%- stars %>"></span></span>
    <%- bedrooms %>  • <%- location %>
    </div>
    </div>
</div>`);
  var SALE_TEMPLATE = (0, _underscore.template)(`
<div class="b-search__item b-search-rental">
    <img src="<%- thumb %>" class=b-search-rental__img>
    <div class=b-search-rental__text>
    <div class=b-search-rental__title><%- title %></div>
    <div class=b-search-rental__meta>
    <%- sale_type %>  • <%- location %>  • <%- area %>  • <%- rooms %>
    </div>
    </div>
</div>`);
  var TEXT_TEMPLATE = (0, _underscore.template)(`
<div class=b-search__item>
    <div class=b-search-text><%- description %></div>
</div>`);
  var EMPTY_TEMPLATE = (0, _underscore.template)(`
<div class=b-search__item>
    <div class="b-search-text b-search-text--empty"><%- title %></div>
</div>`);
  var _default = _exports.default = _backbone.View.extend({
    events: {
      'click .b-header__menu': '_openMenu',
      'click .b-header__search'() {
        if (!this._typeaheadInited) {
          (0, _jquery.default)(this.searchInput).typeahead({
            minLength: 0,
            highlight: false,
            classNames: {
              menu: 'b-search',
              open: 'b-search--open',
              empty: 'b-search--empty',
              dataset: 'b-search__set',
              suggestion: 'b-search__item',
              cursor: 'b-search__item--active',
              highlight: 'b-search__highlight'
            }
          }, {
            name: 'results',
            limit: 10,
            source(query, _sync, cb) {
              (0, _common.getJSON)(`/search-2?text=${query}`).then(cb);
            },
            display(data) {
              return data._query ? data._query : '';
            },
            templates: {
              suggestion(data) {
                switch (data.type) {
                  case 'mode':
                    return MODE_TEMPLATE(data);
                  case 'rent':
                    return RENT_TEMPLATE(data);
                  case 'sale':
                    return SALE_TEMPLATE(data);
                  case 'text':
                    return TEXT_TEMPLATE(data);
                  case 'empty':
                    return EMPTY_TEMPLATE(data);
                }
              }
            }
          });
          this._typeaheadInited = true;
        }
        this._toggleSearch();
      },
      'blur .b-header__search .b-header__search-text': '_closeSearchTry',
      'keydown .b-header__search .b-header__search-text'(ev) {
        var enter = ev.key === 'Enter';
        var value = this.searchInput.value;
        if (enter && !value) {
          return;
        }
        if (enter || ev.key === 'Escape') {
          this._closeSearch();
        }
        if (enter) {
          this.searchKeyword.hidden = false;
          this.searchKeyword.textContent = value;
          setTimeout(() => {
            var _document$querySelect;
            var params = new URLSearchParams({
              text: value
            });
            var view = (_document$querySelect = document.querySelector('main')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.dataset.view;
            if (view === 'rent-list' || view === 'sale-list') {
              location.href = `${location.pathname}?${params}`;
            } else {
              location.href = `/search?${params}`;
            }
          }, 100);
        }
      },
      'typeahead:select .b-header__search'(ev) {
        this._closeSearch();
        location.href = ev.detail.url;
      },
      'click .b-header__search .b-header__search-keyword'(ev) {
        ev.stopPropagation();
        this.searchInput.value = '';
        this.searchKeyword.hidden = true;
        this.searchKeyword.textContent = '';
        setTimeout(() => {
          location.href = location.pathname;
        }, 100);
      }
    },
    initialize() {
      this.model = new _backbone.Model({});
      this.main = this.el.querySelector('.b-header__bar--main');
      this.filter = this.el.querySelector('.b-header__bar--filter');
      var userSection = this.el.querySelector('.b-header-user');
      this.menuUser = userSection.querySelector('.js-user.dropdown');
      this.menuGuest = userSection.querySelector('.js-guest');
      var searchSection = this.el.querySelector('.b-header__search');
      this.searchInput = searchSection.querySelector('.b-header__search-text');
      this.searchLabel = searchSection.querySelector('.b-header__search-label');
      this.searchKeyword = this.searchLabel.querySelector('.b-header__search-keyword');
      if (!this.el.classList.contains('b-header--inverse')) {
        this.headroom = new _headroom.default(this.el, {
          classes: {
            initial: 'b-header--headroom',
            pinned: 'b-header--pinned',
            unpinned: 'b-header--unpinned',
            top: 'b-header--top',
            notTop: 'b-header--not-top',
            bottom: 'b-header--bottom',
            notBottom: 'b-header--not-bottom'
          },
          onUnpin: () => {
            if (!this.preserve()) {
              document.body.click();
            }
          }
        });
        this.headroom.init();
      }
      this.preserve(true);
    },
    _toggleSearch() {
      if (this._searchOpen) {
        this._closeSearch();
      } else {
        this._openSearch();
      }
    },
    _openSearch() {
      document.body.classList.add('s-search');
      this.searchInput.value = this.searchKeyword.textContent;
      this.searchInput.focus();
      addEventListener('scroll', this._windowScroll = this._closeSearchTry.bind(this), {
        once: true,
        passive: true
      });
      this._searchOpen = true;
      this._searchOpenTS = Date.now();
    },
    _closeSearchTry() {
      if (Date.now() - this._searchOpenTS < 1000) {
        return;
      }
      setTimeout(this._closeSearch.bind(this), 300);
    },
    _closeSearch() {
      document.body.classList.remove('s-search');
      removeEventListener('scroll', this._windowScroll);
      this._searchOpen = false;
    },
    _openMenu() {
      GA.menu.show();
    },
    preserve(value) {
      if (typeof value === 'boolean') {
        this._preserve = value;
      } else {
        return this._preserve;
      }
    },
    toggle(flag) {
      this.el.hidden = !flag;
      if (flag) {
        this.headroom.unpin();
      }
    },
    toggleView(list) {
      this.main.hidden = !list;
      this.filter.hidden = !list;
    },
    setUser(user) {
      if (user.role === 'user') {
        var _user$avatar;
        this.menuUser.querySelector('.b-header-user__text').textContent = user.name;
        var avatar = this.menuUser.querySelector('.b-header-user__avatar');
        avatar.src = (_user$avatar = user.avatar) !== null && _user$avatar !== void 0 ? _user$avatar : '/img/avatars/default.png';
        avatar.alt = user.name;
      }
      this.menuGuest.hidden = user.role === 'user';
      this.menuUser.hidden = user.role === 'guest';
    }
  });
});//# sourceMappingURL=header.js.map
;
